// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__13uv_","savePackageButton":"ClientWallet_savePackageButton__3m4se"};